import React from 'react'

import UserLogin from '../section/loginpage/UserLogin'
export default function LoginPage() {
  return (
    <div>
        <UserLogin/>
    </div>
  )
}
